import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const communityEngagementGraphApi = createAsyncThunk(
    'analytics/communityEngagementGraph',
    async (requestData, { rejectWithValue }) => {
        try {
            const { params } = requestData;
            const response = await AuthAxios.get(apiRoutes.communityEngagementGraph(), { params })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const initialState = { result: [], loading: false, error: null, message: "" }

const communityEngagementGraphSlice = createSlice({
    name: 'communityEngagementGraph',
    initialState,
    reducers: {
        resetCommunityEngagementGraph: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(communityEngagementGraphApi.pending, (state) => {
            state.loading = true
        })
        builder.addCase(communityEngagementGraphApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload
        })
        builder.addCase(communityEngagementGraphApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
        })
    },
})

export const { resetCommunityEngagementGraph } = communityEngagementGraphSlice.actions;
export const communityEngagementGraphReducer = communityEngagementGraphSlice.reducer;
